<template>
    <div class="container">
        <div class="form">
            <div class="formItem">
                <div>用户名</div>
                <div class="inputBox">
                    <input type="text" v-model="username" readonly />
                </div>
            </div>
            <div class="formItem">
                <div>旧密码</div>
                <div class="inputBox">
                    <input type="password" v-model="oldPassword" />
                </div>
            </div>
            <div class="formItem">
                <div>新密码</div>
                <div class="inputBox">
                    <input type="password" v-model="newPassword" />
                </div>
            </div>
            <div class="formItem">
                <div>确认新密码</div>
                <div class="inputBox">
                    <input type="password" v-model="confirmPassword" />
                </div>
            </div>
            <div class="formBtns">
                <button class="btn_primary" @click="updatePasswordHttp">保存</button>
            </div>
        </div>
    </div>
</template>

<script>
import { updateAdmin } from "@/http/password";

export default {
    name: "password",
    components: {},
    data() {
        return {
            username: "",
            oldPassword: "",
            newPassword: "",
            confirmPassword: "",
        };
    },
    methods: {
        updatePasswordHttp() {
            // let adminInfo = {
            //   newPassword: '666666',
            //   oldPassword: '777777',
            //   nickname: 'nickname',
            //   company: 'company'
            // }
            if (this.confirmPassword !== this.newPassword) {
                layer.msg("新密码输入不一致");
                return;
            }
            let adminInfo = {
                newPassword: this.newPassword,
                oldPassword: this.oldPassword,
            };
            updateAdmin(adminInfo)
                .then((res) => {
                    console.log(res.data.result);
                    if (res.data.errCode === 0) {
                        let result = res.data.result;
                        if (result) {
                            //修改成功
                            layer.msg("修改成功");
                        } else {
                            layer.msg(res.data.errMsg);
                        }
                    } else if (res.data.errCode === 34) {
                        layer.msg("旧密码错误");
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        },
    },
    watch: {},
    created() {
        // this.updatePasswordHttp()
        this.username = JSON.parse(sessionStorage.getItem("userData")).username;
    },
};
</script>

<style lang="scss" scoped>
.form {
    margin: auto;
    width: 700px;
    padding-top: 100px;
}
.formItem {
    margin-bottom: 30px;
}
.inputBox {
    flex: 1;
    input {
        width: 100%;
        height: 32px;
        padding-left: 10px;
        padding-right: 10px;
        font-size: 16px;
    }
}
.btn_primary {
    width: 200px;
    height: 40px;
}
</style>
